// Shared with the landing-page picker: some mobile providers omit audio MIME types.
export const ACCEPTED_AUDIO_EXTENSIONS = [
  'mp3', 'wav', 'flac', 'ogg', 'oga', 'm4a', 'aac', 'opus',
  'webm', 'mp4', 'aif', 'aiff', 'wma', 'mka',
] as const;
export const AUDIO_FILE_ACCEPT = `audio/*,${ACCEPTED_AUDIO_EXTENSIONS.map(ext => `.${ext}`).join(',')}`;
